import { CDN } from "@/lib/cdn";
export default async function getCardRules(setId: string) {
  try {
    const url = `${CDN}/games/one-piece/data/EN/rules/qa_${setId.toLowerCase()}.json`;
    const res = await fetch(url);

    if (!res.ok) {
      throw new Error("Failed to fetch card rules. Status: " + res.status);
    }
    return res.json();
  } catch (error) {
    // console.error("Error fetching card rules:", error);
    // this is okay, sometimes there are no rules
    return [];
  }
}
